import { app_psnl_menu_set_hdr_RowClass, app_psnl_menu_set_hdr_RowInterface } from "../../dbschema/app_psnl_menu_set_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class PersonalMenuSetHdrContainer extends BaseContainerModel {
  app_psnl_menu_set_hdr: app_psnl_menu_set_hdr_RowInterface = new app_psnl_menu_set_hdr_RowClass();
}